module.exports = __webpack_public_path__ + "static/img/preview-green-no-progress-bar.43a7a6cf.png";